<template>
  <div>
    <div class="man-cell" style="margin: 10px">
      <el-input v-model="search" placeholder="媒体名称："></el-input>
    </div>
    <el-button style="margin: 10px" type="primary" @click="getMedia">搜索</el-button>
    <el-button
      type="primary"
      @click="
        showDialog = true;
        edit = false;
        onRest();
      "
    >添加新媒体</el-button>
    <el-table :data="tableData" highlight-current-row style="width: 100%" v-loading="loading">
      <el-table-column label="媒体名称" prop="name"></el-table-column>
      <el-table-column label="好友数" prop="wechat_media.friends"></el-table-column>
      <el-table-column label="推广类型" prop="channel"></el-table-column>
      <el-table-column label="地区" prop="area"></el-table-column>
      <el-table-column label="年龄" prop="wechat_media.age"></el-table-column>
      <el-table-column label="兴趣爱好" prop="wechat_media.hobby"></el-table-column>
      <el-table-column label="职业" prop="wechat_media.vocation"></el-table-column>
      <el-table-column label="学历" prop="wechat_media.education"></el-table-column>
      <el-table-column label="限单量" prop="wechat_media.dailyQuantities"></el-table-column>
      <el-table-column label="首发价格" prop="wechat_media.topPrice">
        <template slot-scope="scope">
          <a>{{ scope.row.wechat_media.topPrice + scope.row.addPrice }}</a>
        </template>
      </el-table-column>
      <el-table-column label="转发价格" prop="wechat_media.forwardPrice">
        <template slot-scope="scope">
          <a>{{ scope.row.wechat_media.forwardPrice + scope.row.addPrice }}</a>
        </template>
      </el-table-column>
      <!--  -->
      <el-table-column label="备注" prop="remark"></el-table-column>
      <!-- <el-table-column label="平台认证" prop="auth"></el-table-column> -->
      <el-table-column property="openid" label="编辑">
        <template slot-scope="scope">
          <el-button size="mini" @click="onEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="Pagination" style="text-align: left; margin-top: 10px">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="index"
        :page-size="20"
        layout="total, prev, pager, next"
        :total="count"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="!edit ? '添加' : '修改' + '朋友圈社群'"
      :visible.sync="showDialog"
      width="50%"
    >
      <el-form ref="form" label-width="100px">
        <el-form ref="form" label-width="100px">
          <el-form-item label="账号名称：" style="width: 50%; float: left">
            <el-input style="width: 80%" size="small" v-model="name"></el-input>
          </el-form-item>
          <el-form-item label="微信号：" style="width: 50%; float: left">
            <el-input style="width: 80%" size="small" v-model="wechat"></el-input>
          </el-form-item>
          <el-form-item label="兴趣爱好：" style="width: 50%; float: left">
            <el-select v-model="hobby" placeholder="请选择">
              <el-option
                v-for="(item, index) in hobbyList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="从事职业：" style="width: 50%; float: left">
            <el-select v-model="vocation" placeholder="请选择">
              <el-option
                v-for="(item, index) in vocationList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区：" style="width: 50%; float: left">
            <el-cascader
              v-model="city"
              :options="areaList"
              :props="{ value:'label' }"
              separator="-"
              filterable
              clearable
              @change="choseCity"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="好友数量：" style="width: 50%; float: left">
            <el-input style="width: 80%" size="small" type="number" v-model="friends"></el-input>
          </el-form-item>
          <el-form-item label="性别：" style="width: 50%; float: left">
            <el-select v-model="sex" placeholder="请选择">
              <el-option
                v-for="(item, index) in sexList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄：" style="width: 50%; float: left">
            <el-input style="width: 80%" size="small" type="number" v-model="age"></el-input>
          </el-form-item>
          <el-form-item label="学历：" style="width: 50%; float: left">
            <el-select v-model="education" placeholder="请选择">
              <el-option
                v-for="(item, index) in educationList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推广类型：" style="width: 50%; float: left">
            <el-select v-model="channel" placeholder="请选择">
              <el-option
                v-for="(item, index) in channelList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="首发价：" style="width: 50%; float: left">
            <el-input style="width: 80%" size="small" type="number" v-model="topPrice"></el-input>
          </el-form-item>
          <el-form-item label="转发价：" style="width: 50%; float: left">
            <el-input style="width: 80%" size="small" type="number" v-model="forwardPrice"></el-input>
          </el-form-item>
          <el-form-item label="每日单量：" style="width: 100%; float: left">
            <el-select v-model="dailyQuantities" placeholder="请选择">
              <el-option
                v-for="(item, index) in xdList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工作时间：" style="width: 100%; float: left">
            <el-select v-model="workTime" placeholder="请选择">
              <el-option
                v-for="(item, index) in wkList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
		  <el-form-item label="账号简介：" style="width: 100%; float: left">
		    <el-input type="textarea" style="width: 80%" size="small" v-model="description"></el-input>
		  </el-form-item>
		  <el-form-item label="备注内容：" style="width: 100%; float: left">
		    <el-input type="textarea" style="width: 80%" size="small" v-model="wechatRemarks"></el-input>
		  </el-form-item>
        </el-form>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="onChange">
          {{
          edit ? "确认修改" : "确认添加"
          }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import myAxios from "../myAxios";
import areaJson from "../components/area.json";
import cityList from "../components/city.json";
export default {
  data() {
    return {
		description:"",
		wechatRemarks:"",
      city: "",
      count: 0,
      mediaId: "",
      size: 20,
      index: 1,
      tableData: [],
      loading: false,
      username: localStorage.getItem("username"),
      showDialog: false,
      search: "",
      name: "", //账号名称
      wechat: "", //微信号
      hobby: "", //兴趣爱好-选
      vocation: "", //从事职业-选
      area: "", //所在地区
      friends: 0, //好友数量
      sex: "男", //性别
      age: 0, //年龄
      education: "", //学历-选
      channel: "", //推广类型
      topPrice: 0, //价格
      forwardPrice: 0, //价格
	    workTime:"工作日",
      dailyQuantities: "", //每日单量
      startHour: 0, //工作时间
      endHour: 24, //工作时间
      edit: false,
      areaList: [],
	  wkList:["工作日","周六日","法定节假日","随时"],
      xdList: [
        {
          value: "",
          label: "不限"
        },
        {
          value: "1",
          label: "限量一单"
        },
        {
          value: "2",
          label: "限量两单"
        },
        {
          value: "3",
          label: "限量三单"
        }
      ],
      channelList: [
        {
          value: "朋友圈",
          label: "朋友圈"
        },
        {
          value: "社交群",
          label: "社交群"
        }
      ],
      hobbyList: [
        {
          value: "不限",
          label: "不限"
        }
      ],
      vocationList: [
        {
          value: "不限",
          label: "不限"
        }
      ],
      educationList: [
        {
          value: "小学及以下",
          label: "小学及以下"
        },
        {
          value: "小学及以下",
          label: "小学及以下"
        },
        {
          value: "初中/中专",
          label: "初中/中专"
        },
        {
          value: "高中/职高",
          label: "高中/职高"
        },
        {
          value: "专科/本科",
          label: "专科/本科"
        },
        {
          value: "硕士/博士",
          label: "硕士/博士"
        }
      ],
      boolList: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      sexList: [
        {
          value: "男",
          label: "男"
        },
        {
          value: "女",
          label: "女"
        }
      ]
    };
  },
  created() {
    this.hobbyList = areaJson.hobbys;
    this.vocationList = areaJson.wechatChannelList;
    this.areaList = cityList;
    this.getMedia();
  },
  computed: {},
  methods: {
    choseCity(e) {
      this.area =e[0]+"-"+e[1]
      console.log(this.area);
    },
    async getMedia() {
      myAxios
        .get(
          `/client_media/MyMedia/v1?username=${
            this.username
          }&name=${this.search.replace(/\s*/g, "")}&mediaType=6&index=${
            this.index
          }&size=${this.size}`
        )
        .then(res => {
          this.tableData = res.data;
          this.count = res.total;
        });
      this.loading = false;
    },
    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.getMedia();
    },
    onEdit(index, row) {
      this.edit = true;
      this.mediaId = row.wechat_media.mediaId;
      this.showDialog = true;
      this.name = row.name; //账号名称
      this.area = row.area; //所在地区
      this.channel = row.channel; //推广类型

      this.wechat = row.wechat_media.wechat; //微信号
      this.hobby = row.wechat_media.hobby; //兴趣爱好-选
      this.vocation = row.wechat_media.vocation; //从事职业-选
      this.friends = row.wechat_media.friends; //好友数量
      this.sex = row.wechat_media.sex; //性别
      this.age = row.wechat_media.age; //年龄
      this.education = row.wechat_media.education; //学历-选
      this.topPrice = row.wechat_media.topPrice; //首发价
      this.forwardPrice = row.wechat_media.forwardPrice; //转发价
      this.dailyQuantities = row.wechat_media.dailyQuantities; //每日单量
      this.workTime = row.wechat_media.workTime;
    },
    onRest() {
      this.mediaId = "";
      this.name = ""; //账号名称
      this.wechat = ""; //微信号
      this.hobby = ""; //兴趣爱好-选
      this.vocation = ""; //从事职业-选
      this.area = ""; //所在地区
      this.friends = 0; //好友数量
      this.sex = ""; //性别
      this.age = 0; //年龄
      this.education = ""; //学历-选
      this.channel = ""; //推广类型
      this.topPrice = 0; //首发价
      this.forwardPrice = 0; //转发价
      this.dailyQuantities = ""; //每日单量
      this.workTime = ""; //工作时间
    },
    onChange() {
      if (
        this.name == "" ||
        this.wechat == "" ||
        this.hobby == "" ||
        this.vocation == "" ||
        this.area == "" ||
        this.friends == 0 ||
        this.sex == "" ||
        this.age == 0 ||
        this.education == "" ||
        this.channel == "" ||
        this.topPrice == 0 ||
        this.forwardPrice == 0 
      ) {
        this.$alert("信息填写不全", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      if (this.topPrice <= 0 || this.forwardPrice <= 0) {
        this.$alert("金额不小于0", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      var url = `/client_media/AddWechatMedia/v1?username=${this.username}&name=${this.name}&wechat=${this.wechat}&hobby=${this.hobby}&vocation=${this.vocation}&area=${this.area}&friends=${this.friends}&sex=${this.sex}&age=${this.age}&education=${this.education}&channel=${this.channel}&topPrice=${this.topPrice}&forwardPrice=${this.forwardPrice}&dailyQuantities=${this.dailyQuantities}&workTime=${this.workTime}&description=${this.description}&wechatRemarks=${this.wechatRemarks}`;
      if (this.edit) {
        url = `/client_media/UpdateWechatMedia/v1?mediaId=${this.mediaId}&username=${this.username}&name=${this.name}&wechat=${this.wechat}&hobby=${this.hobby}&vocation=${this.vocation}&area=${this.area}&friends=${this.friends}&sex=${this.sex}&age=${this.age}&education=${this.education}&channel=${this.channel}&topPrice=${this.topPrice}&forwardPrice=${this.forwardPrice}&dailyQuantities=${this.dailyQuantities}&workTime=${this.workTime}&description=${this.description}&wechatRemarks=${this.wechatRemarks}`;
      }
      myAxios.post(url).then(res => {
        if (res.code == 0) {
          this.onRest();
          this.showDialog = false;
          this.getMedia();
          this.$message({
            type: "success",
            message: res.data
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
</style>
